const API_BASE_URL = 'https://kooturavu.tn.gov.in/api/v1';

export const API_ENDPOINTS = {
  SOCIETY_TYPES: `${API_BASE_URL}/master/society_type`,
  DISTRICTS: `${API_BASE_URL}/master/district`,
  SOCIETY_LOCATIONS: `${API_BASE_URL}/society/location`,
};

export default API_BASE_URL;